<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      :moreSearchVisible="true"
      permpisionsQuery=""
    >
      <el-alert
        show-icon
        :closable="false"
        title="温馨提示：授信额度是服务商授予车队在其名下油站的预消费额度。已用额度在付款会自动恢复。"
        type="warning" />
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          { // 服务商名称
            label: '服务商名称',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商名称',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
